import { render } from "./Columns.vue?vue&type=template&id=cb52c194"
const script = {}

import "./Columns.vue?vue&type=style&index=0&id=cb52c194&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__